import type { Mission } from '../missions.ts'

export const fna: Mission = {
  id: "fna",
  name: "Food and Nutrition Administration",
  short: "FNA",
  call: "Nutrition",
  kind: "subagency",
  parent: "usda",
  url: "https://www.fna.usda.gov/",
  established: 1969,
  palette: {
    primary: "#045881",
    secondary: "#093c4d",
    accent: "#268140",
  },
  colorSource: {
    kind: "site",
    url: "https://www.fna.usda.gov/",
  },
  motif: "hands",
  mission: {
    text: "Our mission is to nourish those in need through financially sound programs that promote health and work, as well as champion the productivity of American agriculture.",
    url: "https://www.fna.usda.gov/about",
  },
  fact: {
    text: "The agency was established on Aug. 8, 1969, and its nutrition assistance programs serve 1 in 4 Americans over the course of a year.",
    url: "https://www.fna.usda.gov/about",
  },
  identifier: {
    about: "https://www.fna.usda.gov/about",
    accessibility: "https://www.usda.gov/accessibility-statement",
    foia: "https://www.fna.usda.gov/foia",
    noFear: "https://www.usda.gov/about-usda/working-usda/employee-services/usda-no-fear-act-report-information",
    oig: "https://www.oig.usda.gov/",
    performance: "https://www.usda.gov/about-usda/general-information/our-performance",
    privacy: "https://www.usda.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fna-usda-foods-warehouse.jpg",
        small: "/media/fna-usda-foods-warehouse-sm.jpg",
        alt: "Tall blue and orange warehouse racks loaded with pallets of packaged food in a food bank warehouse.",
        title: "Pallets of product in a food bank warehouse, Lorton, Virginia, January 2025",
        creator: "U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:The_Emergency_Food_Assistance_Program_(TEFAP)_(20250110-USDA-FNS-UNK-006).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fna-community-garden.jpg",
        small: "/media/fna-community-garden-sm.jpg",
        alt: "Rows of leafy green chard growing in sunlight, with two greenhouses in the background.",
        title: "Spurs Community Garden, San Antonio Food Bank, San Antonio, Texas, October 31, 2011",
        creator: "U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:20111031-FNS-LSC-0360_(6769456229).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
